import { render, staticRenderFns } from "./AppProfileAlert.vue?vue&type=template&id=0bbace86&scoped=true&"
import script from "./AppProfileAlert.vue?vue&type=script&lang=js&"
export * from "./AppProfileAlert.vue?vue&type=script&lang=js&"
import style0 from "./AppProfileAlert.vue?vue&type=style&index=0&id=0bbace86&lang=scss&scoped=true&"
import style1 from "./AppProfileAlert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbace86",
  null
  
)

export default component.exports